<template>
  <div class="reconciliation-panel">
    <BaseFigures
      :items="items"
      class="reconciliation-panel__figures"
    />

    <BaseDashboardTable
      :columns="columns"
      :rows="rows"
      :item-key="itemKey"
      :hide-default-footer="true"
      :disable-sort="true"
    />
  </div>
</template>

<script>
import BaseFigures from './BaseFigures.vue'
import BaseDashboardTable from './BaseDashboardTable.vue'

export default {
  name: 'BaseReconciliationPanel',
  components: { BaseFigures, BaseDashboardTable },
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.reconciliation-panel {
  &__figures {
    margin-bottom: 16px;
  }
}
</style>
